var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.3571 14.1667H1.59665C0.735692 14.1667 0 14.7997 0 15.5435C0 16.2872 0.735692 17 1.59665 17H21.3109C22.2659 17 23 16.3669 23 15.5833C23 14.7997 22.2658 14.1667 21.3571 14.1667ZM21.3571 0H1.59665C0.735692 0 0 0.634401 0 1.37682C0 2.11924 0.735692 2.83333 1.59665 2.83333H21.3109C22.2659 2.83333 23 2.20026 23 1.41667C23 0.633073 22.2658 0 21.3571 0Z","fill":"white","key":0}),React.createElement("path",{"d":"M23 8.4987C23 9.28096 22.2643 9.91536 21.4033 9.91536H1.59665C0.735692 9.91536 0 9.28229 0 8.4987C0 7.7151 0.735692 7.08203 1.59665 7.08203H21.3109C22.2659 7.08203 23 7.7151 23 8.4987Z","fill":"white","fillOpacity":"0.55","key":1})]);
}

Menu.defaultProps = {"width":"23","height":"17","viewBox":"0 0 23 17","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
